import { inject, Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { SettingsService } from '@infodata-group/inf-commons';

@Injectable()
export class HttpStatusInterceptor implements HttpInterceptor {
  private settingsService = inject(SettingsService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404 && error.statusText.includes('Setting id')) {
          this.settingsService.addSetting(
            'id',
            'e7a900be-7de6-4397-83b0-d3b47ed4145d',
          );
        }
        return throwError(() => error);
      }),
    );
  }
}
